import type { FirestoreTimestamp } from "./types";

export const timestampToDate = (value: FirestoreTimestamp | Date | null | undefined): Date | null => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === "object" && "toDate" in value && typeof value.toDate === "function") {
    return value.toDate();
  }

  return null;
};
